import at from 'lodash/at';
import React, { ChangeEvent } from 'react';

import { ValueBox, ValueInput } from '@candu-ai/craft/ui';
import { PendoOpenGuideAction } from 'craft/types';

import { InteractionFieldProps } from './interactionFields';

export const GuideField = ({
  defaultValue,
  onChange,
}: InteractionFieldProps<PendoOpenGuideAction['handler']>) => {
  // const [errorMessage, setErrorMessage] = useState(null);

  const onChangeHandler = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    // TODO introduce validation messages
    // if (!value) {
    //   return setErrorMessage('Please enter a value');
    // }
    // setErrorMessage(null);
    return onChange({ ...defaultValue, guideId: value });
  };

  return (
    <ValueBox isInGroup={{ isLast: true }}>
      <ValueInput
        placeholder="Write ID"
        value={at(defaultValue as any, 'guideId')[0]}
        onChange={onChangeHandler}
      />
    </ValueBox>
  );
};
